module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    attrs: {
      "show": _vm.showModal,
      "effect": "fade",
      "id": "preset-settings"
    },
    on: {
      "closeOnEscape": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    ref: "closeModalButton",
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Preset Settings")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage.length),
      expression: "errorMessage.length"
    }],
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage),
      expression: "errorMessage"
    }],
    ref: "errorMessage",
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError('errorMessage')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.preset_item_modifier_item.length === 0),
      expression: "preset_item_modifier_item.length === 0"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n\t\t\t\t\t\tNo preset settings yet. Add a Modifier to start.\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModifiersSelection),
      expression: "showModifiersSelection"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clickable pull-right",
    on: {
      "click": function($event) {
        _vm.hideModifiersSelection()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', [_vm._v("Select Modifier Category")]), _vm._v(" "), _c('div', {
    staticClass: "dd"
  }, [_c('ol', {
    staticClass: "dd-list"
  }, _vm._l((_vm.item.modifiers), function(modifierCategory) {
    return _c('li', {
      key: modifierCategory.id,
      staticClass: "dd-item",
      on: {
        "click": function($event) {
          _vm.selectModifierCategory(modifierCategory)
        }
      }
    }, [_c('div', {
      staticClass: "dd-handle",
      class: {
        'active': modifierCategory.id === _vm.activeModifierCategory.id
      }
    }, [_vm._v(" " + _vm._s(modifierCategory.name) + "\n\t\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "pull-right"
    }, [_c('i', {
      staticClass: "fa fa-chevron-right"
    })])])])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.modifiers.length),
      expression: "!item.modifiers.length"
    }],
    staticClass: "alert alert-warning"
  }, [_vm._v("\n\t\t\t\t\t\tThis item doesn't have any modifiers.\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeModifierCategory.name),
      expression: "activeModifierCategory.name"
    }],
    staticClass: "col-md-6"
  }, [_c('h5', [_vm._v("Select Modifier")]), _vm._v(" "), _c('div', {
    staticClass: "dd"
  }, [_c('ol', {
    staticClass: "dd-list"
  }, _vm._l((_vm.modifierItems), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "dd-item",
      on: {
        "click": function($event) {
          _vm.selectModifierItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "dd-handle",
      class: {
        'included': _vm.modifierInSettings(item)
      }
    }, [_c('label', [_c('i', {
      staticClass: "fa check",
      class: {
        'fa-check-square checked': _vm.modifierInSettings(item), 'fa-square-o unchecked': !_vm.modifierInSettings(item)
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t")])])])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingModifierItems && !_vm.modifierItems.length),
      expression: "!loadingModifierItems && !modifierItems.length"
    }],
    staticClass: "alert alert-warning"
  }, [_vm._v("\n\t\t\t\t\t\tThere are no Modifiers in " + _vm._s(_vm.activeModifierCategory.name) + ". Create one "), _c('router-link', {
    attrs: {
      "to": ("/app/menu_manager/modifier_items/" + (_vm.activeModifierCategory.id))
    }
  }, [_vm._v("in Menu Manager.")])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOptionsSelection),
      expression: "showOptionsSelection"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clickable pull-right",
    on: {
      "click": function($event) {
        _vm.hideOptionsSelection()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', [_vm._v("Select Option Category")]), _vm._v(" "), _c('div', {
    staticClass: "dd"
  }, [_c('ol', {
    staticClass: "dd-list"
  }, _vm._l((_vm.optionCategories), function(optionCategory) {
    return _c('li', {
      key: optionCategory.id,
      staticClass: "dd-item",
      on: {
        "click": function($event) {
          _vm.selectOptionCategory(optionCategory)
        }
      }
    }, [_c('div', {
      staticClass: "dd-handle",
      class: {
        'active': optionCategory.id === _vm.activeOptionCategory.id
      }
    }, [_vm._v(" " + _vm._s(optionCategory.name) + "\n\t\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "pull-right"
    }, [_c('i', {
      staticClass: "fa fa-chevron-right"
    })])])])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.optionCategories && !_vm.loadingOptionsCategories),
      expression: "!optionCategories && !loadingOptionsCategories"
    }],
    staticClass: "alert alert-warning"
  }, [_vm._v("\n\t\t\t\t\t\tThere are no Option Categories. Create one "), _c('router-link', {
    attrs: {
      "to": '/app/menu_manager/options'
    }
  }, [_vm._v("in Menu Manager.")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeOptionCategory.name),
      expression: "activeOptionCategory.name"
    }],
    staticClass: "col-md-6"
  }, [_c('h5', [_vm._v("Select Option")]), _vm._v(" "), _c('div', {
    staticClass: "dd"
  }, [_c('ol', {
    staticClass: "dd-list"
  }, _vm._l((_vm.optionItems), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "dd-item",
      on: {
        "click": function($event) {
          _vm.selectOptionItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "dd-handle",
      class: {
        'included': _vm.optionInSetting(item)
      }
    }, [_c('label', [_c('i', {
      staticClass: "fa check",
      class: {
        'fa-check-square checked': _vm.optionInSetting(item), 'fa-square-o unchecked': !_vm.optionInSetting(item)
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t")])])])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingOptionItems && !_vm.optionItems.length),
      expression: "!loadingOptionItems && !optionItems.length"
    }],
    staticClass: "alert alert-warning"
  }, [_vm._v("\n\t\t\t\t\t\tThere are no Options in " + _vm._s(_vm.activeOptionCategory.name) + ". Create one "), _c('router-link', {
    attrs: {
      "to": ("/app/menu_manager/options/" + (_vm.activeOptionCategory.id) + "/option_items")
    }
  }, [_vm._v("in Menu Manager.")])], 1)])]), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModifiersSelection || _vm.showOptionsSelection),
      expression: "showModifiersSelection || showOptionsSelection"
    }],
    ref: "selection"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "settings__container"
  }, [_vm._l((_vm.preset_item_modifier_item), function(modifier, index) {
    return _c('div', {
      key: index,
      staticClass: "preset-option",
      class: {
        'active': modifier.modifier_id === _vm.activeSetting.modifier_id && modifier.modifier_item_id === _vm.activeSetting.modifier_item_id
      },
      on: {
        "click": function($event) {
          _vm.setActive(modifier)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(modifier.modifier_item_name) + "\n\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "counter-container"
    }, [_c('div', {
      staticClass: "incrementer clickable"
    }, [_c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.decrementAmount(modifier, index)
        }
      }
    })]), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(modifier.qty) + "\n\t\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "decrementer clickable"
    }, [_c('i', {
      staticClass: "fa fa-plus clickable",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.incrementAmount(modifier, index)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "remove-modifier clickable",
      on: {
        "click": function($event) {
          _vm.removeModifierCategory(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('ul', {
      staticClass: "list-unstyled options-list"
    }, [_vm._l((modifier.preset_item_modifier_item_option_item), function(option, index) {
      return _c('li', {
        key: index
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(option.option_item_name) + " \n\t\t\t\t\t\t\t\t\t"), _c('div', {
        staticClass: "pill-container"
      }, [_c('i', {
        staticClass: "fa fa-times-circle-o clickable",
        attrs: {
          "aria-hidden": "true"
        },
        on: {
          "click": function($event) {
            _vm.removeOption(modifier, index)
          }
        }
      })])])
    }), _vm._v(" "), _c('li', {
      staticClass: "margin-top-10"
    }, [_c('button', {
      staticClass: "btn btn-outline blue btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.displayOptionsSelection()
        }
      }
    }, [_vm._v("add Option")])])], 2), _vm._v(" "), _c('div', {
      staticClass: "switch-container"
    }, [_c('label', {
      staticClass: "switch-label"
    }, [_vm._v("Can remove")]), _vm._v(" "), _c('el-switch', {
      attrs: {
        "active-color": "#0c6",
        "inactive-color": "#ff4949",
        "active-value": 1,
        "inactive-value": 0,
        "active-text": "Yes",
        "inactive-text": "No"
      },
      model: {
        value: (modifier.can_remove),
        callback: function($$v) {
          _vm.$set(modifier, "can_remove", $$v)
        },
        expression: "modifier.can_remove"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "switch-container"
    }, [_c('label', {
      staticClass: "switch-label"
    }, [_vm._v("Calculate price difference")]), _vm._v(" "), _c('el-switch', {
      attrs: {
        "active-color": "#0c6",
        "inactive-color": "#ff4949",
        "active-value": 1,
        "inactive-value": 0,
        "active-text": "Yes",
        "inactive-text": "No"
      },
      model: {
        value: (modifier.calculate_price_difference),
        callback: function($$v) {
          _vm.$set(modifier, "calculate_price_difference", $$v)
        },
        expression: "modifier.calculate_price_difference"
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "preset-option add"
  }, [_c('button', {
    staticClass: "btn btn-outline blue btn-sm",
    attrs: {
      "type": "button margin-top-20 margin-bottom-20"
    },
    on: {
      "click": function($event) {
        _vm.displayModifiersSelection()
      }
    }
  }, [_vm._v("Add Modifier")])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.item.modifiers.length
    },
    on: {
      "click": function($event) {
        _vm.savePresetSettings()
      }
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-439a149c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MenuManager/Items/PresetSettings.vue
// module id = 707
// module chunks = 0